/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class PredictAPI
 * @hideconstructor
 * @classdesc SmartsServiceAPI interface.
 */
define([], () => {
	class SmartsServiceAPI {
		/**
		 * @function SmartsServiceAPI#runQuery
		 * @description Runs smarts query against a smart service (Predict execution, Smart annotations)
		 * @public
		 * @param {Object} options target and querySpec Mandatory: the query specification to be sent to explore service
		 * @returns a promise
		 */
		runQuery() { }

	}

	return SmartsServiceAPI;
});
